export default class ParametroIngresoSolicitud {

    constructor(){
        this.NumeroSolicitud= 0;
        this.FechaTramite= "";
        this.CodigoEntidad= "";
        this.IdentificacionUsuario= "";
        this.TipoSolicitud= 0;
        this.EstadoSolicitud= 0;
        this.ClaseDato= 0;
        this.IdentificacionPersona= "";
        this.TipoPersona= 0;
        this.PrimerApellido= "";
        this.SegundoApellido= "";
        this.NombreORazonSocial= "";
        this.FechaConstitucionONacimiento= "";
        this.PaisRegistroONacimiento= "";
        this.Genero = 0;
        this.ListaDocumentos = []
    }
    
    NumeroSolicitud: number;
    FechaTramite: string;
    CodigoEntidad: string;
    IdentificacionUsuario: string;
    TipoSolicitud: number;
    EstadoSolicitud: number;
    ClaseDato: number;
    IdentificacionPersona: string;
    TipoPersona: number;
    PrimerApellido: string;
    SegundoApellido: string;
    NombreORazonSocial: string;
    FechaConstitucionONacimiento: string;
    PaisRegistroONacimiento: string;
    Genero?: number;
    ListaDocumentos: []
}